import { render, staticRenderFns } from "./marketingActivities.vue?vue&type=template&id=08acfef1&"
import script from "./marketingActivities.vue?vue&type=script&lang=js&"
export * from "./marketingActivities.vue?vue&type=script&lang=js&"
import style0 from "./marketingActivities.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports